export const SCHEDULE_BOOK_CHART_CONSTANT = {
  //charts
  SCHEDULE_BOOK_COUNT: "/dashboard/schedule/counts",
};
